module.exports = __webpack_public_path__ + "img/generate-01.8f37a28d.png";